import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const scrollPositions = {};

const ScrollToTopOnRouteChange = () => {
  const { pathname, key } = useLocation();
  const navType = useNavigationType();
  const prevKey = useRef(key);

  // Save scroll position before navigating away
  useEffect(() => {
    const saveScroll = () => {
      scrollPositions[prevKey.current] = window.scrollY;
    };

    window.addEventListener("beforeunload", saveScroll);
    return () => {
      saveScroll();
      window.removeEventListener("beforeunload", saveScroll);
    };
  }, []);

  useEffect(() => {
    // Save previous page's scroll position
    if (prevKey.current !== key) {
      scrollPositions[prevKey.current] = window.scrollY;
      prevKey.current = key;
    }

    if (navType === "POP") {
      // Back/forward — restore saved position
      const saved = scrollPositions[key];
      if (saved != null) {
        // Delay to let the page render first
        requestAnimationFrame(() => {
          window.scrollTo(0, saved);
        });
      }
    } else {
      // PUSH or REPLACE — scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname, key, navType]);

  return null;
};

export default ScrollToTopOnRouteChange;
